/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

/**
 * Generated types for CHIRP model: com.hubspot.copilot.models.chat.ChannelEvent
 *
 * [View Java Source](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+ChannelEvent)
 */

export const CHANNEL_EVENT_MODEL_FINGERPRINT = 'mWkEfyxJrTc=';
export const AskAcademyRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.AskAcademyRequest';
export const AskInAppHelpRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.AskInAppHelpRequest';
export const CompanyCompetitorsRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.CompanyCompetitorsRequest';
export const CompanyFundingRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.CompanyFundingRequest';
export const CompanyLookupRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.CompanyLookupRequest';
export const CompanyTechRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.CompanyTechRequest';
export const ContentRewriteRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ContentRewriteRequest';
export const CopilotCapabilitiesRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.CopilotCapabilitiesRequest';
export const CreateBlogPostRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.CreateBlogPostRequest';
export const CreateNewsSubscriptionRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.CreateNewsSubscriptionRequest';
export const CustomSystemPromptRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.CustomSystemPromptRequest';
export const DeleteNewsSubscriptionRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.DeleteNewsSubscriptionRequest';
export const DiscoverCompaniesRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.DiscoverCompaniesRequest';
export const DraftBlogPostRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.DraftBlogPostRequest';
export const DraftSalesEmailRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.DraftSalesEmailRequest';
export const DraftSalesEmailTemplateRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.DraftSalesEmailTemplateRequest';
export const ImageGenerateRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ImageGenerateRequest';
export const ListNewsSubscriptionsRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ListNewsSubscriptionsRequest';
export const ListNotesRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ListNotesRequest';
export const NewsRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.NewsRequest';
export const NoteCreateRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.NoteCreateRequest';
export const NoteCreateTemplateRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.NoteCreateTemplateRequest';
export const ObjectAddRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ObjectAddRequest';
export const ObjectAssignRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ObjectAssignRequest';
export const ObjectAssociationsRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ObjectAssociationsRequest';
export const ObjectCountRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ObjectCountRequest';
export const ObjectListRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ObjectListRequest';
export const ObjectSummaryRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ObjectSummaryRequest';
export const ObjectUpdateRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ObjectUpdateRequest';
export const OrchestrationPlanExecutionRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.OrchestrationPlanExecutionRequest';
export const OrchestrationPlanningRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.OrchestrationPlanningRequest';
export const ReportBuilderRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ReportBuilderRequest';
export const SummarizeArticleRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.SummarizeArticleRequest';
export const TaskCreateRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.TaskCreateRequest';
export const TaskCreateTemplateRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.TaskCreateTemplateRequest';
export const TextGenerateRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.TextGenerateRequest';
export const ActionButtonTypename = 'com.hubspot.chatspot.message.schemas.buttons.ActionButton';
export const ActionButtonV2Typename = 'com.hubspot.chatspot.message.schemas.buttons.ActionButtonV2';
export const LinkButtonTypename = 'com.hubspot.chatspot.message.schemas.buttons.LinkButton';
export const TemplateButtonTypename = 'com.hubspot.chatspot.message.schemas.buttons.TemplateButton';
export const AccordionResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.AccordionResponseSection';
export const ActionsResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.ActionsResponseSection';
export const AvatarCardResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.AvatarCardResponseSection';
export const BarChartResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.BarChartResponseSection';
export const CardWrapperResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.CardWrapperResponseSection';
export const ChipsCardResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.ChipsCardResponseSection';
export const CollaborationResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.CollaborationResponseSection';
export const CompanyOverviewResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.CompanyOverviewResponseSection';
export const ConfirmationResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.ConfirmationResponseSection';
export const CrmCardResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.CrmCardResponseSection';
export const DashboardResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.DashboardResponseSection';
export const DataTableResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.DataTableResponseSection';
export const DenseListResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.DenseListResponseSection';
export const ErrorResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.ErrorResponseSection';
export const FilterBranchResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.FilterBranchResponseSection';
export const GridResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.GridResponseSection';
export const HtmlCardResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.HtmlCardResponseSection';
export const HtmlTextResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.HtmlTextResponseSection';
export const HtmlWithChildrenResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.HtmlWithChildrenResponseSection';
export const InlineCitationResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.InlineCitationResponseSection';
export const LlmResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.LlmResponseSection';
export const MetricCardResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.MetricCardResponseSection';
export const NewsListCardResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.NewsListCardResponseSection';
export const PlainTextResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.PlainTextResponseSection';
export const ReportResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.ReportResponseSection';
export const SourcesListResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.SourcesListResponseSection';
export const TabResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.TabResponseSection';
export const TemplateResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.TemplateResponseSection';
export const ThoughtResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.ThoughtResponseSection';
export const TimelineCardResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.TimelineCardResponseSection';
export const UnstyledImageResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.UnstyledImageResponseSection';
export const UserActionResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.UserActionResponseSection';
export const UserChatResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.UserChatResponseSection';
export const VisualizationResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.VisualizationResponseSection';
export const CardResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.card.CardResponseSection';
export const CompanyCardTypename = 'com.hubspot.chatspot.message.schemas.sections.card.CompanyCard';
export const DoubleCardFieldValueTypename = 'com.hubspot.chatspot.message.schemas.sections.card.DoubleCardFieldValue';
export const IntegerCardFieldValueTypename = 'com.hubspot.chatspot.message.schemas.sections.card.IntegerCardFieldValue';
export const LinkCardFieldValueTypename = 'com.hubspot.chatspot.message.schemas.sections.card.LinkCardFieldValue';
export const StringCardFieldValueTypename = 'com.hubspot.chatspot.message.schemas.sections.card.StringCardFieldValue';
export let ComHubspotChatspotMessageSchemasSectionsCitation;
(function (_ComHubspotChatspotMessageSchemasSectionsCitation) {})(ComHubspotChatspotMessageSchemasSectionsCitation || (ComHubspotChatspotMessageSchemasSectionsCitation = {}));
export const FileAttachmentResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.file.FileAttachmentResponseSection';
export const ImageGridResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.image.ImageGridResponseSection';
export const MediaPreviewResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.media.MediaPreviewResponseSection';
export const MediaPreviewResponseSectionV2Typename = 'com.hubspot.chatspot.message.schemas.sections.media.MediaPreviewResponseSectionV2';
export const MeetingResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.meeting.MeetingResponseSection';
export const BrandVoiceFieldTypename = 'com.hubspot.chatspot.message.schemas.sections.metadata.BrandVoiceField';
export const AISkillSourceDataTypename = 'com.hubspot.chatspot.message.schemas.sections.sources.AISkillSourceData';
export const AppSourceDataTypename = 'com.hubspot.chatspot.message.schemas.sections.sources.AppSourceData';
export const CrmObjectSourceDataTypename = 'com.hubspot.chatspot.message.schemas.sections.sources.CrmObjectSourceData';
export const WebsiteSourceDataTypename = 'com.hubspot.chatspot.message.schemas.sections.sources.WebsiteSourceData';
export const CrossTabVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.crosstab.CrossTabVisualization';
export const DatawellVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.datawell.DatawellVisualization';
export const FunnelVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.funnel.FunnelVisualization';
export const GaugeVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.gauge.GaugeVisualization';
export const PivotVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.pivot.PivotVisualization';
export const SankeyVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.sankey.SankeyVisualization';
export const SlicedVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.sliced.SlicedVisualization';
export const TableVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.table.TableVisualization';
export const WaterfallVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.waterfall.WaterfallVisualization';
export const XYVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.xy.XYVisualization';
export const ActionCellTypename = 'com.hubspot.chatspot.message.schemas.table.ActionCell';
export const ImageCellTypename = 'com.hubspot.chatspot.message.schemas.table.ImageCell';
export const LinkCellTypename = 'com.hubspot.chatspot.message.schemas.table.LinkCell';
export const PlainTextCellTypename = 'com.hubspot.chatspot.message.schemas.table.PlainTextCell';
export const LinkTokenTypename = 'com.hubspot.chatspot.message.schemas.tokens.LinkToken';
export const BooleanFieldValueTypename = 'com.hubspot.chirp.ext.models.BooleanFieldValue';
export const DoubleFieldValueTypename = 'com.hubspot.chirp.ext.models.DoubleFieldValue';
export const FloatFieldValueTypename = 'com.hubspot.chirp.ext.models.FloatFieldValue';
export const IntFieldValueTypename = 'com.hubspot.chirp.ext.models.IntFieldValue';
export const ListFieldValueTypename = 'com.hubspot.chirp.ext.models.ListFieldValue';
export const LongFieldValueTypename = 'com.hubspot.chirp.ext.models.LongFieldValue';
export const MapFieldValueTypename = 'com.hubspot.chirp.ext.models.MapFieldValue';
export const NullFieldValueTypename = 'com.hubspot.chirp.ext.models.NullFieldValue';
export const StringFieldValueTypename = 'com.hubspot.chirp.ext.models.StringFieldValue';
export const ActionRequestTypename = 'com.hubspot.copilot.models.chat.ActionRequest';
export const ChatRequestTypename = 'com.hubspot.copilot.models.chat.ChatRequest';
export const ConfirmationRequestTypename = 'com.hubspot.copilot.models.chat.ConfirmationRequest';
/**
 *  Request for user confirmation of an action. Sent from backend to frontend.
 *  Contains the message with the confirmation section that requires user response.
 */

export const ConfirmationResponseTypename = 'com.hubspot.copilot.models.chat.ConfirmationResponse';
/**
 *  Response to a confirmation request. Sent from frontend to backend.
 *  Contains the message with the updated confirmation section along with whether the action was confirmed.
 */

export const ConfirmationResponseAcknowledgedTypename = 'com.hubspot.copilot.models.chat.ConfirmationResponseAcknowledged';

/**
 *  Represents feedback provided for a copilot message.
 */

export const InteractiveToolCallTypename = 'com.hubspot.copilot.models.chat.InteractiveToolCall';
/**
 *  Interactive tool call message sent from backend to frontend.
 *  Contains the full message with interactive tool payload.
 */

export const UserInterruptTypename = 'com.hubspot.copilot.models.chat.UserInterrupt';
export const EmptyPayloadTypename = 'com.hubspot.copilot.models.chat.payload.EmptyPayload';
export const JsonPayloadTypename = 'com.hubspot.copilot.models.chat.payload.JsonPayload';
/**
 *  JSON payload for the raw output response.
 */

export const ToolCallPayloadTypename = 'com.hubspot.copilot.models.chat.payload.ToolCallPayload';
export const MemoryUpdateTypename = 'com.hubspot.copilot.models.chat.response.MemoryUpdate';
/**
 *  Model representing a memory update event.
 */

export const MessageDeltaTypename = 'com.hubspot.copilot.models.chat.response.MessageDelta';
/**
 *  Represents the data sent with a COPILOT_RESPONSE_MESSAGE_DELTA event.
 */

export const MessageEndTypename = 'com.hubspot.copilot.models.chat.response.MessageEnd';
/**
 *  Represents the data sent with a COPILOT_RESPONSE_MESSAGE_END event.
 */

export const MessageStartTypename = 'com.hubspot.copilot.models.chat.response.MessageStart';
export const ResponseEndTypename = 'com.hubspot.copilot.models.chat.response.ResponseEnd';
/**
 *  Represents the data sent with a COPILOT_RESPONSE_END event.
 */

export const ResponseExceptionTypename = 'com.hubspot.copilot.models.chat.response.ResponseException';
/**
 *  Represents the data sent with a COPILOT_RESPONSE_EXCEPTION event.
 */

export const ResponseStartTypename = 'com.hubspot.copilot.models.chat.response.ResponseStart';
/**
 *  Represents the data sent with a COPILOT_RESPONSE_START event.
 */

export const ThreadTitleUpdateTypename = 'com.hubspot.copilot.models.chat.response.ThreadTitleUpdate';
/**
 *  Model representing a thread title update event.
 */

export const ToolCallEndTypename = 'com.hubspot.copilot.models.chat.response.ToolCallEnd';
export const ToolCallProgressTypename = 'com.hubspot.copilot.models.chat.response.ToolCallProgress';
export const ToolCallStartTypename = 'com.hubspot.copilot.models.chat.response.ToolCallStart';

/**
 *  Defines input for interactive tools with pre-built JSON schema and action context.
 */

export const InteractiveToolResultTypename = 'com.hubspot.copilot.models.chat.tools.interactive.result.InteractiveToolResult';
/**
 *  Represents frontend tool execution results with status and output information.
 */

export const PreviewEndTypename = 'com.hubspot.copilot.models.preview.PreviewEnd';
export const PreviewExceptionTypename = 'com.hubspot.copilot.models.preview.PreviewException';
/**
 *  Represents the data sent with a PREVIEW_EXCEPTION event.
 */

export const PreviewMessageDeltaTypename = 'com.hubspot.copilot.models.preview.PreviewMessageDelta';
/**
 *  Represents the data sent with a PREVIEW_MESSAGE_DELTA event.
 */

export const PreviewResponseDeltaTypename = 'com.hubspot.copilot.models.preview.PreviewResponseDelta';
export const PreviewResponseEndTypename = 'com.hubspot.copilot.models.preview.PreviewResponseEnd';
export const PreviewResponseExceptionTypename = 'com.hubspot.copilot.models.preview.PreviewResponseException';
export const PreviewResponseStartTypename = 'com.hubspot.copilot.models.preview.PreviewResponseStart';
export const PreviewStartTypename = 'com.hubspot.copilot.models.preview.PreviewStart';

/**
 *  Simplified preview result containing only the essential data without full thread/message infrastructure.
 *  Used when preview system stores responses directly without creating threads upfront.
 */

export const CrmCitationTypename = 'com.hubspot.copilot.tools.results.citations.CrmCitation';
export const DashworksCitationTypename = 'com.hubspot.copilot.tools.results.citations.DashworksCitation';
export const LegacyCitationTypename = 'com.hubspot.copilot.tools.results.citations.LegacyCitation';
export const WebPageCitationTypename = 'com.hubspot.copilot.tools.results.citations.WebPageCitation';
export let ComHubspotCopilotToolsResultsCitations;
(function (_ComHubspotCopilotToolsResultsCitations) {})(ComHubspotCopilotToolsResultsCitations || (ComHubspotCopilotToolsResultsCitations = {}));